import {BaseModel} from "../../../../../infrastructure/models/base-model";
import {GameInfoAssetsRequestParams} from "./game-info-assets.request-params";

export class GameInfoModuleItem extends BaseModel {
  key: String;
  title: String;
  subtitle: String;
  url: String;

  constructor(key: String, title: String, subtitle: String, url: String, tooltipDescription: String) {
    super();

    this.key = key;
    this.title = title;
    this.subtitle = subtitle;
    this.url = url;
    this.tooltipDescription = tooltipDescription;
  }

  get icon(): GameInfoAssetsRequestParams {
    return new GameInfoAssetsRequestParams(this.key);
  }
}